// src/components/ui/Input.jsx
export function Input({ className = "", ...props }) {
  return (
    <input
      className={[
        "w-full rounded-lg border border-slate-200 dark:border-slate-700 bg-white dark:bg-slate-800 text-slate-900 dark:text-slate-100 px-3 py-2 text-sm",
        "focus:outline-none focus:ring-2 focus:ring-indigo-500 dark:focus:ring-indigo-500/40",
        className,
      ].join(" ")}
      {...props}
    />
  );
}